import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import Image from 'components/image';
import Video from 'components/video';
import Breadcrumbs from 'components/breadcrumbs';
import InspoAnimatedTitle from 'components/inspo-animated-title';
import ContentWrapper from 'components/content-wrapper';

const InspoHeader = ({ isArticlePage, image, video, title, breadcrumbs }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setIsMounted(true), 2000);
  }, []);
  return (
    <div
      className={cn('inspo-header', {
        'inspo-header--is-article-page': isArticlePage
      })}
    >
      {video && (
        <div className="inspo-header__video-container">
          <Video videoClassName="video--in-inspo-header" {...video}></Video>
        </div>
      )}
      {image && !video && (
        <div className="inspo-header__image">
          <Image theme={Image.themes.background} {...image} eagerLoad></Image>
        </div>
      )}
      <div
        className={cn('inspo-header__content', {
          'inspo-header__content--space-between': breadcrumbs
        })}
      >
        {breadcrumbs && (
          <div className="inspo-header__breadcrumbs-wrapper">
            <Breadcrumbs {...breadcrumbs}></Breadcrumbs>
          </div>
        )}
        {title && (
          <ContentWrapper className="inspo-header__title">
            <InspoAnimatedTitle {...title} isMounted={isMounted} />
          </ContentWrapper>
        )}
      </div>
    </div>
  );
};

InspoHeader.propTypes = {
  isArticlePage: PropTypes.bool,
  image: PropTypes.exact(Image.propTypes),
  video: PropTypes.exact(Video.propTypes),
  title: PropTypes.exact(InspoAnimatedTitle.propTypes),
  breadcrumbs: PropTypes.exact(Breadcrumbs.propTypes)
};

InspoHeader.propTypesMeta = {
  isArticlePage: 'exclude'
};

export default InspoHeader;
